// 新闻
const NEWS = {
  newsList: { apiUrl: '/news/queryNewsList', method: 'POST' }, // 列表
  newsDetail: { apiUrl: '/news/queryNewsByMark', method: 'POST' } // 详情
}
export default NEWS
